var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconBookmarkActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66334 1.60113C8.07869 0.339443 9.88612 0.334887 10.3078 1.59467L11.7323 5.851L16.3116 5.8392C17.6381 5.83553 18.2446 7.52791 17.1322 8.32414L13.4433 10.9636L14.865 15.2117C15.2997 16.5102 13.7955 17.5111 12.7325 16.758L9.01886 14.1295L5.31908 16.7768C4.2605 17.5344 2.75054 16.5427 3.17864 15.2418L4.57783 10.9862L0.87481 8.36563C-0.2424 7.57525 0.3559 5.88021 1.68173 5.87643L6.26142 5.865L7.66334 1.60113Z"
  })));
}
export default SvgCommonIconBookmarkActive;